export default __webpack_public_path__ + "static/media/4.62b1d2ce.jpg";